module.exports = __webpack_public_path__ + "static/media/image_71.7ef3e5e5.png";